// extracted by mini-css-extract-plugin
module.exports = {"sisInputText":"SisInputText_sisInputText__1JYwQ"};